import * as types from "./types";

const applyMetadata = metadata => ({
  type: types.APPLY_METADATA,
  payload: metadata
});

const resetState = () => ({
  type: types.RESET_STATE
});

const setItemsCountPerPage = count => ({
  type: types.SET_ITEMS_COUNT_PER_PAGE,
  payload: count
});

const setPage = page => ({
  type: types.SET_PAGE,
  payload: page
});

const setOrder = order => ({
  type: types.SET_ORDER,
  payload: order
});

const setFilters = filters => ({
  type: types.SET_FILTERS,
  payload: filters
});

const selectInvoice = id => ({
  type: types.SELECT_INVOICE,
  payload: id
});

/* Fetch Invoices */
const fetchingInvoiceListError = error => ({
  type: types.FETCHING_INVOICE_LIST_ERROR,
  payload: error
});

const fetchingInvoiceListSuccess = data => ({
  type: types.FETCHING_INVOICE_LIST_SUCCESS,
  payload: data
});

const fetchingInvoiceList = () => ({
  type: types.FETCHING_INVOICE_LIST
});
/* Fetch Invoices */

/* download Invoice List */
const downloadInvoiceListError = error => ({
  type: types.DOWNLOAD_INVOICE_LIST_ERROR,
  payload: error
});

const downloadInvoiceListSuccess = () => ({
  type: types.DOWNLOAD_INVOICE_LIST_SUCCESS
});

const downloadInvoiceList = request => ({
  type: types.DOWNLOAD_INVOICE_LIST,
  payload: request
});
/* download Invoice List */

export {
  fetchingInvoiceList,
  fetchingInvoiceListError,
  fetchingInvoiceListSuccess,
  downloadInvoiceList,
  downloadInvoiceListError,
  downloadInvoiceListSuccess,
  setItemsCountPerPage,
  setPage,
  setOrder,
  setFilters,
  selectInvoice,
  applyMetadata,
  resetState
};
